import Vue from 'vue'
import Router from 'vue-router'

import Shop from './views/shop/index.vue'
// import List from './views/shop/_shopId/index.vue'
// import GoodDetail from './views/shop/_goodId/index.vue'
// import Entry from './views/shop/entry/index.vue'
import Cart from './views/shop/cart/index.vue'
import Payment from './views/shop/cart/payment/index.vue'
import Detail from './views/shop/cart/detail.vue'
import Detail2 from './views/shop/cart/detail2.vue'
import Check from './views/shop/cart/check/index.vue'
import Info from './views/shop/cart/info/index.vue'

import User from './views/user/'

import Join from './views/user/join/'
import JoinInfo from './views/user/join/JoinInfo.vue'
import JoinVerification from './views/user/join/JoinVerification.vue'

import Login from './views/user/login/'
import LoginIndex from './views/user/login/Login.vue'
import LoginVerification from './views/user/login/LoginVerification.vue'

import Order from './views/order/index.vue'
import OrderList from './views/order/list/index.vue'


//特殊
import { getUserInfo, updateUserLineUserID } from '@/api/user'
import Cookies from 'js-cookie'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/user/login/index'
    },
    {
      path: '/shop',
      name: 'shop',
      redirect: '/shop/cart/payment',
      component: Shop,
      children: [
        {
          path: 'cart',
          name: 'cart',
          component: Cart,
          children: [
            {
              name: 'info',
              path: 'info',
              component: Info
            },
            {
              name: 'detail',
              path: 'detail',
              component: Detail
            },
            {
              name: 'detail2',
              path: 'detail2',
              component: Detail2
            },
            {
              name: 'check',
              path: 'check',
              component: Check
            },
            {
              name: 'payment',
              path: 'payment',
              component: Payment
            }
          ]
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      redirect: '/user/login/index',
      component: User,
      children: [
        {
          path: 'join',
          name: 'join',
          component: Join,
          children: [
            {
              name: 'JoinInfo',
              path: 'JoinInfo',
              component: JoinInfo
            },
            {
              name: 'JoinVerification',
              path: 'JoinVerification',
              component: JoinVerification
            }
          ]
        },
        {
          path: 'login',
          name: 'login',
          component: Login,
          children: [
            {
              name: 'LoginLndex',
              path: 'index',
              component: LoginIndex
            },
            {
              name: 'LoginVerification',
              path: 'LoginVerification',
              component: LoginVerification
            }
          ]
        }
      ]
    },
    {
      path: '/order',
      component: Order,
      redirect: '/order/list',
      children: [
        {
          name: 'orderList',
          path: 'list',
          component: OrderList
        }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  // set Line User ID
  let urlParams = new URLSearchParams(window.location.search);
  let line_user_id = urlParams.get("line_user_id")

  var u = navigator.userAgent,
  ua = navigator.userAgent.toLowerCase(),
  isLineApp = u.indexOf("Line") > -1, // Line 內建瀏覽器
  isFbApp = u.indexOf("FB") > -1, // FB App 內建瀏覽器
  isWeixinApp = ua.match(/MicroMessenger/i) == "micromessenger"; // 微信內建瀏覽器

  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  // 如果是 內建瀏覽器 webview
  if (isLineApp || isFbApp || isWeixinApp) {
    if(isAndroid){
      if(line_user_id == null){
        location.href = `googlechrome://navigate?url=https://ezwash.tw/ez-cli/dist/`;
      }else{
        location.href = `googlechrome://navigate?url=https://ezwash.tw/ez-cli/dist/?line_user_id=${line_user_id}`;
      }
    }else{
      if(/line/i.test(navigator.userAgent.toLowerCase())){
        if(line_user_id == null){
          location.href = `https://ezwash.tw/ez-cli/dist/?openExternalBrowser=1`;
        }else{
          location.href = `https://ezwash.tw/ez-cli/dist/?line_user_id=${line_user_id}&openExternalBrowser=1`;
        }
      }else{
        if(line_user_id == null){
          location.href = `googlechrome://ezwash.tw/ez-cli/dist/`;
        }else{
          location.href = `googlechrome://ezwash.tw/ez-cli/dist/?line_user_id=${line_user_id}`;
        }
      }
    }
    
  }

  // 登入前頁面以外，需確認身份
  let user_is_ok = Cookies.get('user_is_ok');

  // line ID判斷
  console.log("set line user id cookie:", line_user_id)  
  if(line_user_id != "" && line_user_id != null) {
    if(!user_is_ok && (to.path.indexOf('/login/index') !== -1)){
      alert("您尚未完成簡訊認證，先幫您進行綁定程序，請輸入手機號碼後點擊「登入會員」。", "進行簡訊認證", {confirmButtonText: '確認'})
    }
    Cookies.set('line_user_id', line_user_id);
  }


  if(!user_is_ok){
    if (to.path.indexOf('/user') === -1) {
      let userTel = Cookies.get('phone')
      if(!userTel){
        router.replace({ name: 'LoginLndex' })
        return
      }
      getUserInfo({userTel: userTel}).then(res=>{
        console.log('攔截');
        console.log(res)
        if(!res.data){
          // 沒這用戶
          Cookies.remove('phone');
          router.replace({ name: 'LoginLndex' })
        }else{
          Cookies.set('user_is_ok', true);
          updateLineID(userTel, line_user_id)
          next()
        }
      })
    }else{
      next()
    }
  }else{
    let userTel = Cookies.get('phone')
    
    updateLineID(userTel, line_user_id)
    next();
  }
  
  
})
export default router;

function updateLineID(userTel, line_user_id) {
  // update Line User ID
  line_user_id = Cookies.get('line_user_id')
  console.log("update line_user_id", line_user_id)

  
  if(line_user_id != "" && line_user_id != null) {
    updateUserLineUserID({userTel: userTel, lineID: line_user_id}).then(res=>{
      console.log("res". res)
    })
    Cookies.remove('line_user_id');
  }
}